import { memo } from 'react';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJTextObjectEraseRight from '../view/FJTextObjectEraseRight';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import FJConstant from '../../../../constants/FJConstant';

const FJTextObjectEraseRightContainer = memo(function FJObjectEraseRightContainer({ isShow }) {
    useLocalStore();
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);

    return <FJTextObjectEraseRight isShow={isShow && headerTabIndex === FJConstant.CREATIONS} />;
});

FJTextObjectEraseRightContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJTextObjectEraseRightContainer;
